import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-23',
  templateUrl: './23.component.html',
})
export class VbGeneral23Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
